<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">For William.</p>
<p class="p2">I knew you a short time, but I think of you often.</p>
<p class="p2">I hope you are well.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?4785c812